export default {

    setClock() {

        /*
        ** origin from from https://cssanimation.rocks/clocks/
         */

        // Get the local time using JS
        let date = new Date;
        let minutes = date.getMinutes();
        let hours = date.getHours();

        // Create an object with each hand and it's angle in degrees
        let hands = [
            {
                className: 'lotti-hand-hours',
                // 720deg / 24h = 30 + 60min / 2 = 30 [+90deg because of initial position on 9 o'clock]
                angle: (hours * 30) + (minutes / 2) + 90
            },
            {
                className: 'lotti-hand-minutes',
                angle: (minutes * 6)
            }
        ];

        // Loop through each of these hands to set their angle
        for (let j = 0; j < hands.length; j++) {

            let elements = document.querySelectorAll('.' + hands[j].className);

            //animate all clocks on page by iterating through same hands-classes here
            for (let k = 0; k < elements.length; k++) {

                elements[k].style.transform = 'rotate(' + hands[j].angle + 'deg)';
                //elements[k].style.transformOrigin = 'center 35%'; // 35% seems to be the origin of the hands
            }
        }
    }
}